import { SelectOptionMobile } from '@shared/models/catalog.service';
import { CatalogItemValue } from 'app/modules/data/models/catalog';

export function getWidthStr(strLength: number, isMobile: boolean = false): number {
  const padding = isMobile ? 0 : 25;
  return strLength * 7 + padding;
}

export function getWidthStrTableTitle(strLength: number): number {
  const multiplier = 8;
  const titleWidth = strLength * multiplier;
  return Math.min(titleWidth, 250);
}

export function columnValueWidth(data: CatalogItemValue[], fileColumnNames: string[] = []): object {
  return data.reduce((acc: object, value: CatalogItemValue) => {
    if (value) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.keys(value).forEach(v => {
        if (value[v]) {
          let currentLength = 10;
          if (Array.isArray(value[v])) {
            if (value[v].length) {
              if (value[v][0].value) {
                currentLength = value[v][0].value.toString().length;
              } else {
                currentLength = 30;
              }
            }
          } else {
            const valueLength = value[v].toString().length;
            if (fileColumnNames.includes(v)) {
              currentLength = Math.ceil(valueLength / 2);
            } else {
              currentLength = valueLength;
            }
          }

          if (!acc[v as keyof typeof acc]) {
            (acc[v as keyof typeof acc] as number) = currentLength;
          } else if ((acc[v as keyof typeof acc] as number) < currentLength) {
            (acc[v as keyof typeof acc] as number) = currentLength;
          }
        }
      });
    }

    return acc;
  }, {});
}

export function dynamicColumnWidth(
  data: CatalogItemValue[],
  column: SelectOptionMobile,
  fileColumnNames: string[],
  breakPointScreen: number,
  isSortAvailable = false,
): number {
  const maxWidth = breakPointScreen === 5
    ? 200
    : breakPointScreen === 1 ? 350 : 500;
  const columnValueWidthData = columnValueWidth(data, fileColumnNames);
  const columnWidthValue = columnValueWidthData[column?.name as keyof typeof columnValueWidthData] as number;
  const strTitleWidth = getWidthStrTableTitle(column?.calculationWidth);
    const strValueWidth = isNaN(columnWidthValue)
      ? 0
      : getWidthStr(columnWidthValue);
    const strWidth = Math.max(strTitleWidth, strValueWidth);
    const cellWidth = (columnWidthValue && columnWidthValue >= column?.calculationWidth)
      ? Math.min(getWidthStr(columnWidthValue), maxWidth)
      : Math.min(strWidth, maxWidth);
  const sortIconWidth = column.name === 'numberClientOpod'
    ? 0
    : breakPointScreen === 1 || breakPointScreen === 5 ? 15 : 75;
    return isSortAvailable ? cellWidth + sortIconWidth : cellWidth;
}

export function staticColumnWidth(
  data: CatalogItemValue[],
  column: SelectOptionMobile,
  fileColumnNames: string[],
  isGlobalIdColumn: boolean,
  breakPointScreen: number,
  isSortAvailable: boolean,
): number {
  const maxWidth = breakPointScreen === 5
    ? 120
    : breakPointScreen === 1 ? 200 : 500;
  const columnValueWidthData = columnValueWidth(data, fileColumnNames);
  const faultPx = isGlobalIdColumn &&
    !(breakPointScreen === 5 || breakPointScreen === 1)
      ? 60
      : 0;
  let columnWidthValue = columnValueWidthData[column?.name as keyof typeof columnValueWidthData] as number;
  if (isGlobalIdColumn) {
    if (breakPointScreen === 5) {
      columnWidthValue = Math.ceil(columnWidthValue / 1.8);
    } else if (breakPointScreen === 1) {
      columnWidthValue = Math.ceil(columnWidthValue / 1.4);
    }
  }
  const cellWidth = (columnWidthValue && columnWidthValue >= column?.calculationWidth)
    ? Math.min((getWidthStr(columnWidthValue) + faultPx), maxWidth)
    : Math.min((getWidthStrTableTitle(column.calculationWidth) + faultPx), maxWidth);
  const sortIconWidth = breakPointScreen === 5
    ? 0
    : breakPointScreen === 1 ? 15 : 75;
  return isSortAvailable ? cellWidth + sortIconWidth : cellWidth;
}
